import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 26 26"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      stroke: "#006C5B",
      d: "M19.094 1.516C17.74 1.204 15.515 1 13 1s-4.74.204-6.094.516a6.99 6.99 0 0 0-5.39 5.39C1.204 8.26 1 10.485 1 13s.204 4.74.516 6.094a6.99 6.99 0 0 0 5.39 5.39C8.26 24.796 10.485 25 13 25s4.74-.204 6.094-.516a6.99 6.99 0 0 0 5.39-5.39C24.796 17.74 25 15.515 25 13s-.204-4.74-.516-6.094a6.99 6.99 0 0 0-5.39-5.39Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#006C5B",
      fillRule: "evenodd",
      d: "M8.25 12a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 .75.75H17l.75.001v.024a2 2 0 0 1-.011.175 3.8 3.8 0 0 1-.615 1.716c-.656.984-1.906 1.834-4.124 1.834s-3.468-.85-4.124-1.834a3.8 3.8 0 0 1-.615-1.716 3 3 0 0 1-.01-.175v-.015l-.001-.005zH9zm1.69.75q.073.165.184.334c.344.516 1.095 1.166 2.876 1.166s2.532-.65 2.876-1.166q.112-.17.183-.334zM6.653 9.368l.003-.004.014-.024A4 4 0 0 1 7 8.873l.073.089a4 4 0 0 1 .257.378l.014.024.003.005a.75.75 0 0 0 1.307-.737L8 9l.654-.368-.001-.001v-.002l-.003-.003-.007-.013a4 4 0 0 0-.105-.172 5 5 0 0 0-.283-.403 3 3 0 0 0-.439-.461C7.664 7.45 7.376 7.25 7 7.25s-.664.201-.816.327a3 3 0 0 0-.438.461 5 5 0 0 0-.389.575l-.007.013-.002.003v.002L6 9l-.653-.368a.75.75 0 0 0 1.306.736m.517-.656-.01.005zm-.33.005-.01-.005zm11.814.651.002-.004.014-.024.058-.094A4 4 0 0 1 19 8.873l.073.089a4 4 0 0 1 .257.378l.014.024.003.005a.75.75 0 0 0 1.307-.737L20 9l.654-.368-.001-.001v-.002l-.003-.003-.007-.013a4 4 0 0 0-.105-.172 5 5 0 0 0-.283-.403 3 3 0 0 0-.439-.461c-.152-.126-.44-.327-.816-.327s-.664.201-.816.327a3 3 0 0 0-.439.461 5 5 0 0 0-.388.575l-.007.013-.002.003v.002L18 9l-.653-.368a.75.75 0 0 0 1.306.736m.515-.656-.01.005zm-.329.005-.01-.005z",
      clipRule: "evenodd"
    }
  )
);
var SvgSentimentPositiveOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var SentimentPositiveOutlined_default = SvgSentimentPositiveOutlined;

export { SentimentPositiveOutlined_default as default };
